import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import store from "@/store";
import router from "@/router";
import useDate from "@/utils/hooks/useDate";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";

import { privilegeCodeTemplateModel } from "@/models/privilege/privilege-code-template";

import { codeTemplateList } from "@/@fake-db/mock-code-template/code-template-list";
import useCodeTemplate from "../../code-template-info/hooks/useCodeTemplate";

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useCodeTemplateList(props) {
  const vm = getCurrentInstance().proxy;
  const { getPermissionModule } = usePermissionByAccount()
  const { openModal, closeModal } = useModal();
  const {
    openDefaultErrorModal,
    openErrorModal,
    openWarningModal,
  } = useValidationModal();

  const {
    getCodeTemplateList,
    deleteCodeTemplate,
    getTemplateLink,
    changeActiveStatus,
  } = privilegeCodeTemplateModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const { resolveDateWithSeperator, resolveTime } = useDate();

  const { getTemplate } = useCodeTemplate();

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  });

  const urlDataLink = ref(null);

  const fields = [
    { key: "no", label: "No." },
    { key: "title", label: "Title" },
    { key: "privilege", label: "Pivileges Name" },
    { key: "template_ref", label: "Template Reference" },
    { key: "privilege_ref", label: "Privilege Reference" },
    //{ key: "template_type_desc", label: "Template" },
    { key: "valid_from", label: "Valid From" },
    { key: "valid_through", label: "Valid Through" },
    { key: "expire_date", label: "Expire Date" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ]);

  const statusAction = reactive({
    ACTIVE: 1,
    INACTIVE: 2,
  });

  const codeTemplateActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "EditIcon",
      display: true,
    },
    preview: {
      label: "Preview",
      value: 2,
      icon: "PreviewIcon",
      display: true,
    },
    copy: {
      label: "Copy Link",
      value: 3,
      icon: "CopyLinkIcon",
      display: true,
    },
    exportcode: {
      label: "ExportCode",
      value: 4,
      icon: "DownloadIcon",
      display: true,
    },
    delete: {
      label: "Delete",
      value: 5,
      icon: "DeleteIcon",
      display: true,
    },
  });

  const isShowCreateBtn = ref(true);

  const setDefaultActiveTab = () => {
    localStorage.removeItem("activeTab");
  };

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case codeTemplateActionList.edit.value:
        setDefaultActiveTab();
        router
          .push(
            `/privilege/code-template/info/${item.item.template_id}?templateType=${item.item.template_type}&privilegeRef=${item.item.privilege_ref}`
          )
          .catch(() => {});
        return;
      case codeTemplateActionList.preview.value:
        modalType.previewModal = true;
        fetchData(item.item);
        openModal();
        return;
      case codeTemplateActionList.copy.value:
        onGetTemplateLink(item.item);
        return;
      case codeTemplateActionList.exportcode.value:
        modalType.exportCodeInfoModal = true;
        fetchData(item.item);
        openModal();
        return;
      case codeTemplateActionList.delete.value:
        removeCodeTemplate(item.item);
      default:
    }
  };

  const modalType = reactive({
    codeTemplate: false,
    previewModal: false,
    copyLink: false,
    exportCodeInfoModal: false,
  });

  const openCodeTemplateModal = () => {
    modalType.codeTemplate = true;
    openModal();
  };

  const closeCodeTemplateModal = () => {
    closeModal();
    modalType.codeTemplate = false;
  };

  const closeCopyLinkModal = () => {
    closeModal();
    modalType.copyLink = false;
  };

  const closePreviewModal = () => {
    closeModal();
    modalType.previewModal = false;
  };

  const closeExportInfoModal = () => {
    closeModal();
    modalType.exportCodeInfoModal = false;
  };

  const codeTemplateTable = reactive({
    payload: [],
  });

  const fetchCodeTemplateList = () => {
    loading.tableData = true;
    getCodeTemplateList.payload.Page = pagination.currentPage;
    getCodeTemplateList.payload.Limit = pagination.perPage;
    getCodeTemplateList.payload.Filters = filters;
    getCodeTemplateList.payload.Ordering = ordering.value;

    store
      .dispatch("api/apiRequest", getCodeTemplateList)
      .then((response) => {
        isShowCreateBtn.value = true;
        codeTemplateTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        const errResp = error.data.error;

        if (errResp && errResp.http_status == 500) {
          isShowCreateBtn.value = false;
          openErrorModal(
            "เกิดข้อผิดพลาด",
            "ขออภัย แบรนด์นี้ไม่ได้ทำการเปิดใช้เมนู Code Template กรุณาติดต่อ Choco CRM"
          );
        } else {
          openDefaultErrorModal(error);
        }
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const onGetTemplateLink = (item) => {
    window.$loading(true);
    getTemplateLink.payload.Template_Id = item.template_id;

    store
      .dispatch("api/apiRequest", getTemplateLink)
      .then((response) => {
        urlDataLink.value = response.data.link;
        modalType.copyLink = true;
        openModal();
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchCodeTemplateList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchCodeTemplateList();
    },
    { deep: true }
  );
  const template_Id = ref(null);
  const template_Data = ref(null);

  const fetchData = (templateObj) => {
    template_Id.value = templateObj.template_id;
    template_Data.value = templateObj;
  };

  const removeCodeTemplate = (codeTemplate) => {
    openWarningModal(
      "ลบ Privilege Code Template",
      `ต้องการลบ ${codeTemplate.title} ใช่หรือไม่`,
      () => {
        deleteCodeTemplate.payload.Template_Id = codeTemplate.template_id;
        store
          .dispatch("api/apiRequest", deleteCodeTemplate)
          .then((response) => {
            fetchCodeTemplateList();
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {});
      }
    );
  };

  const onChangeStatus = (event, item) => {
    let status = 0;
    if (event == true) status = 1;
    else status = 2;

    // window.$loading(true);
    changeActiveStatus.payload.Template_Id = item.template_id;
    changeActiveStatus.payload.Status = status;

    store
      .dispatch("api/apiRequest", changeActiveStatus)
      .then((response) => {
        fetchCodeTemplateList();
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  onBeforeMount(() => {
    fetchCodeTemplateList();
  });

  return {
    loading,
    fields,
    statusOption,
    codeTemplateTable,
    pagination,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,

    codeTemplateActionList,
    modalType,
    openCodeTemplateModal,
    closeCodeTemplateModal,
    closeCopyLinkModal,
    resolveMappingTableAction,
    resolveDateWithSeperator,
    resolveTime,
    removeCodeTemplate,
    closePreviewModal,
    closeExportInfoModal,
    getTemplate,

    template_Id,
    template_Data,
    urlDataLink,
    isShowCreateBtn,
    statusAction,
    onChangeStatus,
    getPermissionModule
  };
}
